import React from "react";
import { cn, formatNumber } from "@/lib/utils";
import { currencyIconClass, currencyLabel, isSaudiRiyal } from "@/lib/currency";

export interface PriceProps {
	value: number | string;
	/** ISO currency code (e.g. "SAR"); defaults to SAR when omitted. */
	currency?: string;
	className?: string;
}

/**
 * Renders a money amount in the active currency.
 * SAR uses the Riyal glyph font (`icon-saudi_riyal` ::before); any other
 * currency appends its ISO code as a small suffix.
 */
export function Price({ value, currency, className }: PriceProps) {
	const amount = Number(value);
	const formatted = formatNumber(Number.isFinite(amount) ? amount : 0);

	if (isSaudiRiyal(currency)) {
		return (
			<span dir="ltr" className={cn("tabular-nums", currencyIconClass(currency), className)}>
				{formatted}
			</span>
		);
	}

	return (
		<span dir="ltr" className={cn("tabular-nums", className)}>
			{formatted}
			<span className="ms-1 text-[0.75em] font-normal text-muted-foreground">
				{currencyLabel(currency).toUpperCase()}
			</span>
		</span>
	);
}

export default Price;
